// These constants are injected via webpack environment variables.
// You can add more variables in webpack.common.js or in profile specific webpack.<dev|prod>.js files.
// If you change the values in the webpack config files, you need to re run webpack to update the application

export const VERSION = process.env.VUE_APP_VERSION;
export const DEBUG_INFO_ENABLED = process.env.VUE_APP_DEBUG_INFO_ENABLED;
export const SERVER_API_URL = process.env.VUE_APP_SERVER_API_URL;
export const ROBOT_API_URL = process.env.VUE_APP_ROBOT_API_URL;


export const BUILD_TIMESTAMP = process.env.BUILD_TIMESTAMP;

export const APPLICATION_NAME = "Portale dipendente";

// Errors
export const PROBLEM_BASE_URL = "https://www.jhipster.tech/problem";
export const EMAIL_ALREADY_USED_TYPE = PROBLEM_BASE_URL + "/email-already-used";
export const LOGIN_ALREADY_USED_TYPE = PROBLEM_BASE_URL + "/login-already-used";
export const INVALID_PASSWORD = PROBLEM_BASE_URL + "/invalid-password";
export const GENERIC_ERROR_MESSAGE = "Si è verificato un errore";

export const ANDROID_APP_URL = "https://play.google.com/store/apps/details?id=it.seasoft.sealav";
export const IOS_APP_URL = "https://apps.apple.com/it/app/winpeople/id1601460702";

export const PASSWORD_POLICY = "La password deve avere una lunghezza minima di 8 caratteri, contenere almeno un carattere minuscolo, uno maiuscolo, un numero e un carattere speciale.";

export const copyright = '2021 SeaSoft';

export const distributions = [
  { text: "EBridge", value: "001" },
  { text: "Robot", value: "002" },
  { text: "Norma", value: "003" },
];

export const tipiRichiesta = [
  {
    text: "Modifica dati anagrafici",
    value: 1,
    error:
      "Per la tipologia di richiesta selezionata è necessario allegare il documento di modifica dati anagrafici, compilato e firmato, da scaricare dalla sezione 'Documenti'."
  },
  {
    text: "Modifica IBAN",
    value: 2,
    error:
      "Per la tipologia di richiesta selezionata è necessario allegare il documento di modifica IBAN, compilato e firmato, da scaricare dalla sezione 'Documenti'."
  },
  {
    text: "Modifica contatti",
    value: 3,
    error:
      "Per la tipologia di richiesta selezionata è necessario indicare nel campo testo i contatti da modificare (telefono, email ecc.)."
  },
  {
    text: "Richiesta documenti",
    value: 4,
    error:
      "Per la tipologia di richiesta selezionata è necessario indicare nel campo testo la descrizione del documento richiesto."
  },
  {
    text: "Richieste azienda",
    value: 5,
    error:
      ""
  }
];

export const statiRichiesta = [
  { text: "Inviata", value: "I" },
  { text: "In valutazione", value: "V" },
  { text: "Lavorata", value: "L" },
  { text: "Rifiutata", value: "R" },
];

export const mesi = [
  "Gennaio",
  "Febbraio",
  "Marzo",
  "Aprile",
  "Maggio",
  "Giugno",
  "Luglio",
  "Agosto",
  "Settembre",
  "Ottobre",
  "Novembre",
  "Dicembre"
];

export const colors = {
    primarycolor : "#06c",
}

export const MAX_FILE_SIZE = 2097152;
